import { render, staticRenderFns } from "./Szqj.vue?vue&type=template&id=75dd48b9&scoped=true"
import script from "./Szqj.vue?vue&type=script&lang=js"
export * from "./Szqj.vue?vue&type=script&lang=js"
import style0 from "./Szqj.vue?vue&type=style&index=0&id=75dd48b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dd48b9",
  null
  
)

export default component.exports